function formatVenueArea(areas) {
    if (areas.length) {
          return `in ${areas.join(", ")}`;
    }

    return "";
}

export default formatVenueArea;
